import {Component, Inject, Optional} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef, MatDialogContent} from "@angular/material/dialog";
import {StaffingComment} from "../../../../../core/models/staffing-comment";
import {TranslatableComponent} from "../../../../../core/models/TranslatableComponent";
import {TranslateService, TranslatePipe} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";
import {CdkScrollable} from "@angular/cdk/scrolling";
import {MatFormField, MatLabel, MatError} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {ReactiveFormsModule, FormsModule} from "@angular/forms";
import {EscapeHotkeyDirective} from "../../../../../shared/hotkey/directives/escape-hotkey.directive";
import {SaveHotkeyDirective} from "../../../../../shared/hotkey/directives/save-hotkey.directive";

@Component({
	selector: "app-staffing-comment-dialog",
	templateUrl: "./staffing-comment-dialog.component.html",
	imports: [
		MatIcon,
		CdkScrollable,
		MatDialogContent,
		MatFormField,
		MatLabel,
		MatInput,
		ReactiveFormsModule,
		FormsModule,
		MatError,
		EscapeHotkeyDirective,
		SaveHotkeyDirective,
		TranslatePipe,
	],
})
export class StaffingCommentDialogComponent extends TranslatableComponent {
	comment: any;
	displayErrorMessage: boolean;

	constructor(
		public dialogRef: MatDialogRef<StaffingCommentDialogComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: StaffingComment,
		public translate: TranslateService,
	) {
		super(translate, "StaffingCommentDialogComponent");
		this.comment = {...data};
		this.dialogRef.addPanelClass("mep-dialog");
	}

	save(value: HTMLTextAreaElement) {
		if (value.value.trim() === "") {
			this.displayErrorMessage = true;
		} else {
			this.dialogRef.close({data: this.comment});
		}
	}

	closeDialog() {
		this.dialogRef.close(null);
	}
}
